import { createSearchParams } from "react-router-dom";

export function isRtl(text: string, clinicRtlDisplay: boolean): boolean {
  return clinicRtlDisplay || isHebrew(text); //if take rtlDisplay from session settings else determine by text
}
export function isHebrew(text: string) {
  return text && text.slice(0, 10).match(/[\u0590-\u05fe]+/) !== null;
}

export function navigateWithLocale(
  path: string,
  locale: string,
  options?: any,
) {
  return {
    pathname: path,
    search:
      locale && locale !== "en"
        ? `?${createSearchParams({ lang: locale })}`
        : null,
    ...options,
  };
}
